<template lang="pug">
GodModal#duplicateFoundConfirmModal(
  v-if="modelValue && mode === 'confirm'",
  title="",
  :height="'auto !important'",
  :width="$isMobile ? '95%' : '480px'",
  :window-class="'pb-2'",
  :main-content-padding="$isMobile ? '1rem 1rem 0 1rem' : '2rem 2rem 0 2rem'",
  :overlay="true",
  :scrollable-background="false",
  :close-on-overlay-click="false",
  :close-on-button-click="true",
  :show-close-button="false",
  :callback-functions=`{
    mainButton: 'confirm-data',
    secondaryButton: 'make-changes',
  }`,
  :button-names=`{
    mainButton: $t('duplicate_modal_confirm_yes_btn'),
    secondaryButton: $t('duplicate_modal_confirm_no_btn'),
  }`,
  :button-classes=`{
    mainButton: ['w-full lg1024:w-1/2 mb-2 lg1024:mb-0'],
    secondaryButton: ['border-2', 'border-gray-4', 'w-full lg1024:w-1/2'],
  }`,
  @confirm-data="$emit('confirmData')",
  @make-changes="$emit('makeChanges')"
)
  div(class="lg1024:px-8 lg1024:pt-8 pt-8 px-4")
    h3.text-xl.font-medium.text-center(class="lg1024:text-2xl") {{ $t('name_email_checkout_duplicate_found_1') }}
    p.mt-4.pb-4.text-mainColor.opacity-75 {{ $t('name_email_checkout_duplicate_found_1_text') }}

GodModal#duplicateFoundAuthModal(
  v-if="modelValue && mode === 'auth'",
  title="",
  :height="'auto !important'",
  :width="$isMobile ? '95%' : '480px'",
  :window-class="'pb-2'",
  :main-content-padding="$isMobile ? '1rem 1rem 0 1rem' : '2rem 2rem 0 2rem'",
  :overlay="true",
  :scrollable-background="false",
  :close-on-overlay-click="false",
  :close-on-button-click="true",
  :show-close-button="false",
  :callback-functions=`{
    mainButton: 'go-to-auth',
  }`,
  :button-names=`{
    mainButton: $t('duplicate_modal_auth_btn'),
  }`,
  :button-classes=`{
    mainButton: ['w-full lg1024:w-1/2 mx-auto text-[16px]'],
  }`,
  @go-to-auth="$emit('goToAuth')"
)
  div(class="lg1024:px-8 lg1024:pt-8 pt-8 px-4")
    h3.text-xl.font-medium.text-center.mb-4(class="lg1024:text-2xl") {{ $t('name_email_checkout_duplicate_found_2') }}
    p(v-html="$t('name_email_checkout_duplicate_found_2_text')" ).mt-4.pb-4.text-mainColor.opacity-75
</template>

<script>
import GodModal from './GodModal.vue'

export default {
  name: 'DuplicateFoundModal',
  components: {
    GodModal,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'confirm',
      validator: (v) => ['confirm', 'auth'].includes(v),
    },
  },
  emits: ['update:modelValue', 'confirmData', 'makeChanges', 'goToAuth'],
  mounted() {
    document.body.style.overflow = 'auto'
  },
}
</script>

<style scoped>
#duplicateFoundConfirmModal :deep(.modal-window),
#duplicateFoundAuthModal :deep(.modal-window) {
  max-width: 480px;
}
</style>
